import Form, { FormProps } from "@/shared/form/form";
import Input from "@/shared/form/input";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { FieldsType } from "../../../model/types";
import { ReactNode } from "react";
import { useTemplateProperties } from "../../../model/property-provider/property-context";
import { NotificationForm } from "../../../../../shared/notification-form";

type TemplateFormViewProps = FormProps & {
  partOf?: boolean;
  forDynamicProcess?: boolean;
  propertyTree?: ReactNode;
};

export function TemplateFormView({
  partOf,
  forDynamicProcess,
  propertyTree,
  ...formProps
}: TemplateFormViewProps) {
  const properties = useTemplateProperties();

  return (
    <Form {...formProps}>
      {!forDynamicProcess && (
        <Form.Item<FieldsType> name="code" hidden>
          <Input />
        </Form.Item>
      )}

      <NotificationForm.Title name={"title"} properties={properties} />
      <NotificationForm.Body name={"body"} properties={properties} />
      <NotificationForm.PrettyMessage
        name={"prettyBody"}
        properties={properties}
        propertyTree={propertyTree}
      />

      {!partOf && (
        <SubmitWrapper>
          <SubmitButton />
        </SubmitWrapper>
      )}
    </Form>
  );
}
